import React, { useState, useEffect } from "react";
import { WhiteBoxWrapper } from "./Login.style";
import UserCard, { User } from "./UserCard";
import { Card, Col, Nav, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fetchAPI } from "../utils/fetchAPI";
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa";

const UsersList = () => {
  const [users, setUsers] = useState<User[]>([]); // Stan dla danych użytkowników
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Funkcja do pobierania użytkowników
  const fetchUsers = async () => {
    setIsLoading(true);
    setErrorMessage("");

    try {
      const data = await fetchAPI("GET", "users.php");

      if (data && data.success) {
        setUsers(data.data); // Ustaw dane użytkowników
      } else {
        throw new Error(data?.message || "Nie udało się pobrać użytkowników.");
      }
    } catch (error: any) {
      setErrorMessage(error.message || "Wystąpił błąd podczas pobierania danych.");
    } finally {
      setIsLoading(false);
    }
  };

  const generateExcel = () => {
    // Przygotuj dane do eksportu
    const exportData = users.map((user) => ({
      Imię: user.name,
      Nazwisko: user.surname,
      Stanowisko: user.position,
      "Przypisane urządzenia": user.currentDevices.map((device) => device.name).join(", "),
    }));

    // Utwórz nowy arkusz
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lista Pracowników");

    // Zapisz plik
    XLSX.writeFile(wb, "lista_pracownikow.xlsx");
  };

  // useEffect do pobierania danych przy montowaniu komponentu
  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <WhiteBoxWrapper>
        <Row className="align-items-center">
          <Col xs={9}>
            <h2 className="text-center">
              <b>Lista pracowników</b>
            </h2>
          </Col>
          <Col xs={3}>
            <h2>
              <Nav.Link className="btn btn-primary" as={Link} to="/useradd">
                +
              </Nav.Link>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="d-flex justify-content-end mt-3">
            <Button variant="primary" onClick={generateExcel}>
              <FaFileExcel className="me-2" /> Generuj Excel
            </Button>
          </Col>
        </Row>
      </WhiteBoxWrapper>
      <Card className="p-2 bg-brand-gren">
        {isLoading && <p>Ładowanie danych...</p>}
        {errorMessage && <p className="error">{errorMessage}</p>}
        {!isLoading && !errorMessage && users.length > 0 && (
          <div>
            {users.map((user) => (
              <UserCard data={user} />
            ))}
          </div>
        )}
        {!isLoading && !errorMessage && users.length === 0 && <p>Brak danych do wyświetlenia.</p>}
      </Card>
    </div>
  );
};

export default UsersList;
